<section class="rcx-table" [formGroup]="exitClearanceForm">
  <div class="row">
    <div class="col-lg-12">
      <div class="card btr">
        <div class="card-content">
          <div class="card-body">
            <div class="row">
              <div class="row g-3">
                <div class="col-md-3" *ngIf="context.persona === 'HR'">
                  <label class="form-label">Assert Returned <b class="text-secondary">*</b></label>
                  <div class="d-flex align-items-center">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="yesAssertReturned" name="assertReturned"
                        [value]="true" formControlName="assertReturned" />
                      <label class="form-check-label" for="yesAssertReturned">Yes</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="noAssertReturned" name="assertReturned"
                        [value]="false" formControlName="assertReturned" />
                      <label class="form-check-label" for="noAssertReturned">No</label>
                    </div>
                  </div>
                </div>
                <div class="col-md-3" *ngIf="context.persona === 'HR'">
                  <label class="form-label">HR Verified<b class="text-secondary">*</b></label>
                  <div class="d-flex align-items-center">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="yesHrVerified" name="hrVerified" [value]="true"
                        formControlName="hrVerified" />
                      <label class="form-check-label" for="yesHrVerified">Yes</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="noHrVerified" name="hrVerified" [value]="false"
                        formControlName="hrVerified" />
                      <label class="form-check-label" for="noHrVerified">No</label>
                    </div>
                  </div>
                </div>
                <div class="col-md-3" *ngIf="context.persona === 'HR'">
                  <label class="form-label">Admin Verified<b class="text-secondary">*</b></label>
                  <div class="d-flex align-items-center">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="yesAdminVerified" name="adminVerified"
                        [value]="true" formControlName="adminVerified" />
                      <label class="form-check-label" for="yesAdminVerified">Yes</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="noAdminVerified" name="adminVerified"
                        [value]="false" formControlName="adminVerified" />
                      <label class="form-check-label" for="noAdminVerified">No</label>
                    </div>
                  </div>
                </div>
                <div class="col-md-3" *ngIf="context.persona === 'EMPLOYEE'">
                  <label for="status" class="form-label">Assert Returned<b class="text-secondary">*</b></label>
                  <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                        class='bx bx-building'></i></span>
                    <input type="text" class="form-control ps-1" id="status" placeholder="Enter the Assert Returned"
                      autocomplete="off" readonly  [value]="exitClearanceForm.get('assertReturned')?.value ? 'Yes' : 'No'" />
                  </div>
                </div>
                <div class="col-md-3" *ngIf="context.persona === 'EMPLOYEE'">
                  <label for="status" class="form-label">HR Verified<b class="text-secondary">*</b></label>
                  <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                        class='bx bx-building'></i></span>
                    <input type="text" class="form-control ps-1" id="status" placeholder="Enter the hr Verified"
                      autocomplete="off" readonly  [value]="exitClearanceForm.get('hrVerified')?.value ? 'Yes' : 'No'" />
                  </div>
                </div>
                <div class="col-md-3" *ngIf="context.persona === 'EMPLOYEE'">
                  <label for="status" class="form-label">Admin Verified<b class="text-secondary">*</b></label>
                  <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                        class='bx bx-building'></i></span>
                    <input type="text" class="form-control ps-1" id="status" placeholder="Enter the admin Verified"
                      autocomplete="off" readonly  [value]="exitClearanceForm.get('adminVerified')?.value ? 'Yes' : 'No'" />
                  </div>
                </div>
                <div class="col-md-3">
                  <label for="date" class="form-label">Date<b class="text-secondary">*</b></label>
                  <div class="input-group"> <span class="input-group-text bg-transparent  border-end-0"><i
                        class='bx bx-calendar'></i></span>
                    <input type="date" class="form-control ps-1" id="date" formControlName="date"
                      [readOnly]="context.persona === 'EMPLOYEE'" />
                  </div>
                </div>
                <div class="col-md-3">
                  <label for="resignationStatus" class="form-label">Status</label>
                  <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-repost'></i></span>
                    <ng-select class="form-control rcx-ng-select" formControlName="status"
                      placeholder="Select a Resignation Status" [readonly]="context.persona === 'EMPLOYEE'"
                      [ngClass]="{'is-invalid': submitted && s.status.errors}" >
                      <ng-option *ngFor="let status of statuses" [value]="status">
                        {{status}} 
                      </ng-option>
                    </ng-select>
                  </div>
                  <div
                  *ngIf="exitClearanceForm.get('status')?.invalid && (exitClearanceForm.get('status')?.dirty || exitClearanceForm.get('status')?.touched)">
                  <small class="text-danger" *ngIf="exitClearanceForm.get('status').errors?.required">Please select the
                    status.</small>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>